import React, {useState} from "react";
import {getMessaging, onMessage} from "firebase/messaging";
import {Tabs, Tab, Box} from "@mui/material";
import {useUser} from "../UserContext.js";
import AdminAddLocate from "./AdminAddLocate.js";
import AdminAddUser from "./AdminAddUser.js";
import "./../Styles.css";
import AdminManageFiles from "./AdminManageFiles.js";
import TraderPage from "../trader/TraderPage.js";
import {AdminProvider} from "./AdminContext.js";
import {useSnackbar} from "notistack";

export default function AdminPage() {
  const {appUser} = useUser();
  const [value, setValue] = useState(appUser?.role === "admin" ? 0 : 1);
  const {enqueueSnackbar} = useSnackbar();

  const messaging = getMessaging();
  onMessage(messaging, (payload) => {
    enqueueSnackbar(`${payload.notification?.title} ${payload.notification.body}`, {variant: "info"});
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <AdminProvider>
      <Box sx={{
        bgcolor: "background.paper", alignItems: "center", margin: "auto", width: "100%"
      }}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant='scrollable'
          aria-label='scrollable auto tabs example'>
          <Tab label='Requests' />
          {appUser?.account && <Tab label='Allocate' />}
          <Tab label='Locates' />
          <Tab label='Users' />
        </Tabs>
        <div className="column" align="center">
          {value === 0 && <AdminManageFiles />}
          {value === 1 && appUser?.account && <TraderPage />}
          {value === 2 && <AdminAddLocate />}
          {value === 3 && < AdminAddUser />}
        </div>
      </Box>
    </AdminProvider>
  );
}
